<script setup>

import {
	site as siteConfig,
	footer_navigation_1_data,
	footer_navigation_2_data,
	contact_information
} from "~app_root/public/tv/app.config";

import SizeHelper from "@/Components/Misc/SizeHelper.vue";
import { Head } from '@inertiajs/vue3';
import LanguagePicker from "@/Components/LanguagePicker.vue";
import WhatsAppLink from "@/Components/WhatsAppLink.vue";
import ContactInfoMenuItem from "@/Components/Misc/ContactInfoMenuItem.vue";
import MyAccountMenuItem from "@/Components/Misc/MyAccountMenuItem.vue";
import Strip from "@/Components/Misc/Strip.vue";
import { Link } from '@inertiajs/vue3';

import CountdownTimer from "@/Components/Misc/CountdownTimer.vue";

</script>

<template>

	<Head>
		<title head-key="title">{{ __config(siteConfig.pages.home.title) }}</title>
		<meta name="description" :content="__config(siteConfig.pages.home.description)" head-key="description" />

		<link rel="canonical" :href="$page.props.ziggy.location" />
	</Head>

	<!-- Header -->

	<!-- Size Helper - only on local -->
	<SizeHelper v-if="$page.props.env == 'local'"></SizeHelper>

	<!-- Add to cart confirmation modal -->
	<AddToCartConfirmationModal v-if="$store.state.cart.recently_added_item" />

	<!-- Generic modal -->
	<GenericModal v-if="$store.state.central.show_modal" />

	<!-- WhatsApp link -->
	<WhatsAppLink v-if="contact_information.show_whatsapp_button" :floating="true" />

	<NewsletterPopup v-if="uicontrol.show_newsletter_popup && !$store.state.central.subscribed_to_newsletter"
		@hide="uicontrol.show_newsletter_popup = false" />

	<ConsentPopup />

	<Popups />

	<div id="headerWrapper" class="container-fluid bg-white header-wrapper" ref="headerWrapper"
		:style="uicontrol.headerWrapperStyle">

		<Strip @mounted="updateLayout()" group="top" />

		<!--<div class="mb-lg-3" style="width: 100%; height: 32px; display: flex; justify-items: center; background-color: #000000; margin-left: -15px; width: calc(100% + 30px);">-->
		<!--	<CountdownTimer :deadline="'2024-11-11T00:00:00'" class="container sizexs"/>-->
		<!--</div>-->

		<div class="container mx-auto p-0">

			<!-- Header -->
			<div class="header">

				<div class="header-panel d-flex justify-content-between w-100 px-0">

					<div class="d-flex align-items-center">

						<Link title="home" :href="route('home')">
						<img alt="logo_small" src="/images/ui/logo_small.webp" width="160" preload="auto"
							style="max-width: 30vw;">
						</Link>

					</div>

					<div class="d-flex align-items-center justify-content-end header-panel-buttons-wrapper flex-grow-1">

						<!-- Search component in header panel-->
						<search :category="'products'" class="mt-1 mx-4 d-none d-lg-block flex-grow-1"></search>

						<LanguagePicker v-if="!$page.props.store.is_b2b || !$page.props.auth.user" />

						<ContactInfoMenuItem />

						<div class="pe-lg-2 px-1">
							<Link :href="route('favorites')" :title="__('favorites')">
							<i class="lnr icon-heart"></i> <span class="d-none d-xl-inline">
								{{ __('favorites') }}
							</span>
							</Link>
						</div>

						<MyAccountMenuItem />

						<div @click="uicontrol.show_minicart_extended = true"
							v-if="!$page.props.store.is_b2b || $page.props.auth.user">
							<minicart :title="__('shopping_cart')"></minicart>
						</div>

					</div>

				</div>

				<minicart_extended v-if="uicontrol.show_minicart_extended"
					@hide_minicart_extended="uicontrol.show_minicart_extended = false"></minicart_extended>

				<div class="header-content d-flex align-items-center justify-content-center w-100 pb-2 pt-0 pt-lg-2">

					<!-- Burger menu button -->
					<div class="burger-menu-button d-block d-lg-none me-2"
						@click="uicontrol.mobile_navigation_visible = true">
						<i class="lnr icon-menu"></i>
					</div>

					<!-- Search component-->
					<search :category="'products'" class="d-block d-lg-none w-100"></search>

					<!-- Main Navigation -->
					<navigation :id="'main_navigation'"
						:structure="$store.state.central.main_navigation_data[$page.props.locale]"
						:show_close_button="true" :show_navigation_background="true"
						@hide_navigation="uicontrol.mobile_navigation_visible = false"
						:class="{ 'visible': uicontrol.mobile_navigation_visible }"
						v-if="$store.state.central.main_navigation_data?.[$page.props.locale]">
					</navigation>

				</div>
			</div>
		</div>
	</div>

	<div class="header-wrapper-placeholder d-block d-lg-none" :style="uicontrol.headerWrapperPlaceholderStyle"></div>




	<!-- Content from Pages/*.vue goes inside this slot-->
	<slot></slot>

	<div class="mt-5"></div>

	<div id="footer" class="footer w-100 p-4">
		<div class="container">
			<div class="row">

				<div class="col-lg-3">
					<div class="logo-wrapper mb-1">
						<img src="/images/ui/logo.webp" alt="Logo" width="160" height="45">
					</div>
					<p class="line-height-180">
						{{ __config(siteConfig.about) }} </p>
				</div>

				<div class="col-lg-3 col-md-6">

					<span class="column-title">
						{{ __('how_to_buy') }}
					</span>

					<!-- Bottom Navigation -->
					<navigation :id="'footer_navigation_1'" :structure="footer_navigation_1_data[$page.props.locale]"
						:show_close_button="false"></navigation>
				</div>

				<div class="col-lg-3 col-md-6">

					<span class="column-title">
						{{ __('useful_information') }}
					</span>

					<navigation :id="'footer_navigation_2'" :structure="footer_navigation_2_data[$page.props.locale]"
						:show_close_button="false"></navigation>

				</div>

				<div class="col-lg-3">

					<span class="column-title">
						{{ __('newsletter.newsletter') }}
					</span>

					<p v-if="siteConfig.showNewsletterDiscountText">{{ __('newsletter.discount_text') }}</p>

					<FooterNewsletterSubscription class="mb-0" />

				</div>

			</div>

		</div>
	</div>

	<div class="container-fluid sub-footer">
		<div class="row">
			<div class="col-12 text-center mb-2">
				<p class="text-small font-light">Copyright © {{ new Date().getFullYear() }} {{ __config(siteConfig.name)
				}}. {{ __('all_rights_reserved') }} </p>
				<span class="text-white cursor-pointer " @click="throwError">-</span>

			</div>
		</div>
	</div>

</template>

<script>

import search from '@/Components/Search/Search.vue';
import navigation from '@/Components/Navigation/Navigation.vue';
import minicart from '@/Components/ECart/Minicart.vue';
import minicart_extended from '@/Components/ECart/MinicartExtended.vue';
import GenericModal from "@/Components/Misc/GenericModal.vue";
import AddToCartConfirmationModal from "@/Components/ECart/AddToCartConfirmationModal.vue";
import FooterNewsletterSubscription from "@/Components/Misc/FooterNewsletterSubscription.vue";
import NewsletterPopup from "@/Components/Newsletter/NewsletterPopup.vue";
import Popups from "@/Components/Misc/Popups.vue";
import ConsentPopup from "@/Components/Misc/ConsentPopup.vue";

export default {
	name: "MainLayout",

	data() {
		return {
			uicontrol: {
				mobile_navigation_visible: false,
				show_minicart_extended: false,
				show_header_contact: false,
				headerWrapperStyle: {},
				headerWrapperPlaceholderStyle: {},
				show_newsletter_popup: false
			},
			headerWrapperHeight: 0,
			scrolledDownAmount: 0,
			window: null
		}
	},

	components: {
		search,
		navigation,
		minicart,
		minicart_extended,
		AddToCartConfirmationModal,
		GenericModal,
		FooterNewsletterSubscription,
		NewsletterPopup,
		Popups,
		ConsentPopup
	},

	watch: {

		uicontrol: {
			handler(data) {
				this.updateBodyOverflow();
			},
			deep: true
		}

	},

	mounted() {


		if (this.$page.props.flash.success || this.$page.props.flash.error) {
			this.$store.dispatch('central/showModal', {
				title: this.$page.props.flash.success?.title || this.$page.props.flash.error?.title,
				content: this.$page.props.flash.success?.content || this.$page.props.flash.error?.content,
			});
		}


		this.$store.dispatch('central/loadMainNavigation', this.$page.props.locale);
		this.updateBodyOverflow();
		this.updateLayout();
		this.initializeStickyHeader();
		window.addEventListener('resize', this.updateLayout);

		// Receive events from other components
		this.emitter.on('appLoaded:seconds', (seconds) => {
			if (seconds == 30 && siteConfig.showNewsletterPopup && !localStorage.getItem('newsletter_window_closed')) {
				this.uicontrol.show_newsletter_popup = true;
			}
		});

	},

	methods: {

		throwError() {
			throw new Error('Sentry Error');
		},

		initializeStickyHeader() {

			window.addEventListener('scroll', () => {

				// if width more than 991px, do nothing
				if (window.innerWidth > 991) {
					return;
				}

				let direction = window.scrollY > this.scrolledDownAmount ? 'down' : 'up';

				let scrolledMoreThanHeaderHeight = window.scrollY > this.headerWrapperHeight;

				// transition if scrolled more than header height, no transition if not
				this.uicontrol.headerWrapperStyle['transition'] = scrolledMoreThanHeaderHeight ? 'margin-top 0.3s' : 'none';

				if (direction === 'up') {

					// if scrolled more than header height, and direction is up, show header
					this.uicontrol.headerWrapperStyle['margin-top'] = '0px';

				} else if (scrolledMoreThanHeaderHeight && direction === 'down') {

					// if scrolled more than header height, and direction is down, hide header
					this.uicontrol.headerWrapperStyle['margin-top'] = (this.headerWrapperHeight * -1) + 'px';

				} else {

					// if not scrolled more than header height, show header with negative margin equal to scroll amount
					this.uicontrol.headerWrapperStyle['margin-top'] = window.scrollY * -1 + 'px';

				}

				// update scrolled down amount
				this.scrolledDownAmount = window.scrollY;

			});

		},

		updateLayout() {

			// get header wrapper height
			this.headerWrapperHeight = this.$refs.headerWrapper?.clientHeight || 117;

			// update header wrapper placeholder height
			this.uicontrol.headerWrapperPlaceholderStyle.height = this.headerWrapperHeight + 'px';

		},

		/**
		 * Update body overflow
		 */
		updateBodyOverflow() {

			if (typeof document !== 'undefined') {
				if (this.uicontrol.show_minicart_extended || this.uicontrol.mobile_navigation_visible) {
					document.body.classList.add('overflow-hidden');
				} else {
					document.body.classList.remove('overflow-hidden');
				}
			}

		}

	}

}

</script>